<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row mb-3 d-flex justify-content-end">
              <div class="col-auto pr-0 pl-0">
                <CButton v-if="permissions.clients.add" color="success" @click="createClient()">
                  <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $t('clients.label') }}
                </CButton>
              </div>
              <div class="col-auto pr-0 pl-0">
                <CButton color="primary" @click="importFile()">
                  <CIcon :content="$options.importIcon" /> {{ $t('import') }}
                </CButton>
              </div>
              <div class="col-auto pr-0 pl-0">
                <CButton color="primary" @click="exportFile()">
                  <CIcon :content="$options.exportIcon" /> {{ $t('export') }}
                  </CButton>
              </div>
              <div class="col-auto pr-0 pl-0">
                <CButton color="primary" @click="printData()">
                  <CIcon :content="$options.printIcon" /> {{ $t('button.print') }}
                </CButton>
              </div>
              <div class="col-auto pr-0 pl-0 mr-2">
                <CButton color="primary" @click="downloadTemplate()">
                  <CIcon :content="$options.downloadIcon" /> {{ $t('base_file') }}
                </CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableOptions.tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              sorter
              :pagination="tableOptions.pagination"
              @pagination-change="updatePerPage"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
            >
              <template #order_frequency="{item}">
                <td>
                  {{item.order_frequency }} {{ $t('fields.days') }}
                </td>
              </template>
              <template #status="{item}">
                <td>
                  <CBadge :color="item.status_class">
                    {{ item.status ? $t('fields.active') : $t('fields.inactive') }}
                  </CBadge>
                </td>
              </template>
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.clients.read" class="dropdown-item" type="button" @click="showClient(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.clients.edit" class="dropdown-item" type="button" @click="editClient(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.clients.delete" class="dropdown-item" type="button" @click="deleteClient(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import i18n from "../../i18n";
import localeMixin from '../../mixins/locale';
import { cilPlus, cilPrint, cilDataTransferDown, cilDataTransferUp, cilCloudDownload } from '@coreui/icons';

export default {
  name: 'Clients',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  printIcon: cilPrint,
  importIcon: cilDataTransferDown,
  exportIcon: cilDataTransferUp,
  downloadIcon: cilCloudDownload,
  data() {
    return {
      // items: [],
      fields: [
        { key: 'name', label: i18n.t('fields.name') },
        { key: 'address', label: i18n.t('fields.address')},
        { key: 'address2', label: i18n.t('fields.address2')},
        { key: 'city', label: i18n.t('fields.city')},
        { key: 'state', label: i18n.t('fields.state')},
        { key: 'zipcode', label: i18n.t('fields.zipcode')},
        { key: 'phone', label: i18n.t('fields.phone')},
        { key: 'phone2', label: i18n.t('fields.phone2')},
        { key: 'order_frequency', label: i18n.t('fields.order_frequency')},
        { 
            key: 'status', 
            label: i18n.t('fields.is_active'),           
            sorter: true,
        },
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      you: null,
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('clients.search_placeholder'),
        lazy: false,
        external: true
      },
      tableOptions: {
        sorter: true,
        pagination: true,
        tableFilter: {
          label: i18n.t('search'),
          placeholder: i18n.t('clients.search_placeholder'),
          lazy: false,
          external: true
        }
      }
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase()) || 
        i.address.toLowerCase().includes(this.search.toLowerCase()) ||
        i.address2.toLowerCase().includes(this.search.toLowerCase()) ||
        i.city.toLowerCase().includes(this.search.toLowerCase()) ||
        ((!i.state) ? '' : i.state.toLowerCase()).includes(this.search.toLowerCase()) ||
        ((!i.zipcode) ? '' : i.zipcode).includes(this.search.toLowerCase()) ||
        i.phone.includes(this.search.toLowerCase() ||
        i.phone2.includes(this.search.toLowerCase()));
      });
    }
  },
  mounted() {
    this.getClients();
  },
  methods: {
    showClient (id) {
      this.$router.push({ name: 'Client', params: {id} });
    },
    editClient(id) {
      this.$router.push({ name: 'EditClient', params: {id} });
    },
    deleteClient (id) {
      this.$swal({
        title: i18n.t('clients.modal.delete_label'),
        html: i18n.t('clients.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/clients/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              i18n.t('clients.modal.deleted_label'),
              i18n.t('clients.modal.deleted_body'),
              'success'
              );
              this.getClients();
          });
        }
      });
    },
    createClient () {
      this.$router.push({ name: 'CreateClient'});
    },
    getClients () {
      this.loading = true;
      axios.get('/api/clients?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.items = response.data;
        this.items.forEach(elem => {
          elem.status_class = elem.status ? "primary" : "secondary";
        });
        
        this.loading = false;
      }).catch(error => {
        console.error(error);
        if (error.response.status === 401) {
            this.$router.push({ path: '/login' });
        }
      });
    },
    closeOptions() {
      const dropdownElement = document.querySelectorAll(".show");
      dropdownElement.forEach(elem => {
        elem.classList.remove("show");
      });
    },
    async importFile() {
      let fileUpload = '';

      const { value: file } = await this.$swal({
        title: 'Select File to import',
        input: 'file',
        inputAttributes: {
          'accept': 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'aria-label': 'Upload your file'
        },
        showCloseButton: true,
        showCancelButton: true,
      });

      if (file) {
        const fileUpload = document.querySelector('.swal2-file').files[0];
        const formData = new FormData();
        formData.append('client_file', fileUpload);
        axios.post('/api/import/clients', formData)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.status === 'success') {
              this.$swal(
                data.title,
                data.body,
                data.status
              ).then(result => {
                // this.goBack();
                this.getClients();
              });
            }
          }
        });
      }
    },
    exportFile() {
      axios({ 
        url: '/api/export/clients?token=' + localStorage.getItem("api_token"),
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        fileLink.setAttribute('download', 'clientes.xls');
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    downloadTemplate() {
      window.open('/public/downloads/clientes_importar.xls');
    },
    updatePerPage(val) {
      this.perPage = val;
    },
    printData() {
      let url = process.env.VUE_APP_API_ENDPOINT+'api/clients?print=true&token=' + localStorage.getItem("api_token") + '&results=' + this.perPage;
      window.open(url);
    }
  }
}
</script>

